import React, { useState } from 'react'
import IntroAnimation from '../../organisms/IntroAnimation/IntroAnimation'
import HeroSection from '../../molecules/Cryptonary/HeroSection'
import OverviewSection from '../../molecules/Cryptonary/OverviewSection'
import ChallengeSection from '../../molecules/Cryptonary/ChallengeSection'
import WhatWeBuiltSection from '../../molecules/Cryptonary/WhatWeBuiltSection'
import FeaturesSection from '../../molecules/Cryptonary/FeaturesSection'
import CommanFooterCard from '../../atoms/CommanFooterCard/CommanFooterCard'
import colors from '../../theme/color'
import Testimonial from '../../molecules/Testimonial/Testimonial'
import Message from '../../molecules/Message/Message'
import Questions from '../../molecules/Questions/Questions'
import Footer from '../../organisms/Footer/Footer'
import cryptonarybg from '../../../assets/images/cryptonary/cryptonarybg.webp'

const CryptonaryPage = () => {
  const [startAnimation, setStartAnimation] = useState(false)
  const [introKey] = useState(() => Date.now())

  return (
    <div
      className="page-scaler relative min-h-screen overflow-hidden text-white"
      style={{
        backgroundColor: colors.deepNavy,
        backgroundImage: `linear-gradient(to bottom, ${colors.cryptonaryPageGradientFrom}, ${colors.cryptonaryPageGradientVia}, ${colors.cryptonaryPageGradientTo})`,
      }}
    >
      {/* INTRO ANIMATION */}
      <IntroAnimation
      key={introKey}
        words={['CRYPTO', 'PLATFORM']}
        wordColors={['#22c55e', '#16a34a']} 
        backgroundGradient={{
          top: '#1f4e25',
          bottom: '#112b14',
        }}
        onHeroStart={() => setStartAnimation(true)}
      />

      {/* HERO */}
      <HeroSection /* startAnimation={startAnimation} */ />

      <OverviewSection />
      <ChallengeSection />
      <WhatWeBuiltSection />
      <FeaturesSection />
      <Testimonial className="mx-auto mb-20 max-w-[90%]" themeColor="green" />

      <div className="w-full" style={{ backgroundColor: colors.cryptonarySectionBase }}>
        <div className="mb-10 px-4 md:px-8 2xl:mx-20 xl:px-12">
          <div className="grid w-full grid-cols-1 gap-5 xl:min-h-[620px] 2xl:min-h-[710px] lg:grid-cols-[1fr_1fr] xl:grid-cols-[1fr_2fr]">
            <Message themeColor="green" />
            <Questions themeColor="green" />
          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default CryptonaryPage